import { render, staticRenderFns } from "./settingForm.vue?vue&type=template&id=0fa7e448&scoped=true"
import script from "./settingForm.vue?vue&type=script&lang=js"
export * from "./settingForm.vue?vue&type=script&lang=js"
import style0 from "./settingForm.vue?vue&type=style&index=0&id=0fa7e448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa7e448",
  null
  
)

export default component.exports